import { Injectable } from '@angular/core';
import { EmployeeControllerService } from '@iota/iota-management-portal-v4-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';
import { LoadAllEmployeesByCompany, LoadEmployeesFailure, LoadEmployeesSuccess } from '../actions/employee.actions';

@Injectable()
export class EmployeeEffects {
    loadAllEmployeesByCompany$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadAllEmployeesByCompany),
            mergeMap(({ companyId }) =>
                this.apiService.getAllEmployeesByCompany(companyId).pipe(
                    take(1),
                    map((employees) => LoadEmployeesSuccess({ employees })),
                    catchError((error) => of(LoadEmployeesFailure({ error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private apiService: EmployeeControllerService
    ) {}
}
